import { AppState } from '../types'

export const stylesPageSelector = (state: AppState) => state.styles.page

export const stylesSelector = (state: AppState) => state.styles.list
